"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.slugify = exports.getURLParameters = exports.getURLParameter = void 0;
/**
 * Get the value of the specified parameter name from the URL query string. Returns null if the parameter is not found.
 */
exports.getURLParameter = function (paramName) {
    var params = exports.getURLParameters();
    return params[paramName] || null;
};
/**
 * Get a key/value pair map of parameters from the URL query string.
 */
exports.getURLParameters = function () {
    var parameters = typeof window !== 'undefined' && window.location.search.slice(1).split('&') || [];
    var result = {};
    parameters.forEach(function (parameter) {
        var pair = parameter.split('=');
        result[pair[0]] = pair[1] || '';
    });
    return result;
};
/**
 * Creates a URL-friendly string to use as a "slug".
 */
exports.slugify = function (text) {
    return text.toString().toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^\w-]+/g, '')
        .replace(/--+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
};
